import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AffectationService {

  initialValue: boolean = false;
  refreshAffectationSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.initialValue);

  constructor(private http: HttpClient) { }
  affectationServiceFilter( body: any, version = ""): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}${version}/service-affectation/search`, body);
  }

  toggleRefreshData() {
    this.refreshAffectationSource.next(!this.refreshAffectationSource.value)
  }

  getRefreshData(): Observable<boolean> {
    return this.refreshAffectationSource.asObservable();
  }


  addAffectationService( body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/service-affectation`, body);
  }

  getAllAffectation(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/service-affectation`);
  }


  toggleVisibilityAffectation(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/service-affectation/isvisible`, body);

  }
}
